var map = {
	"./home": [
		53226,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		3226
	],
	"./home/": [
		53226,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		3226
	],
	"./home/assets": [
		87054,
		9,
		8770,
		7054
	],
	"./home/assets/": [
		87054,
		9,
		8770,
		7054
	],
	"./home/assets/icons": [
		94235,
		9,
		4235
	],
	"./home/assets/icons/": [
		94235,
		9,
		4235
	],
	"./home/assets/icons/branding.png": [
		32762,
		1,
		2762
	],
	"./home/assets/icons/gaming.png": [
		41730,
		1,
		1730
	],
	"./home/assets/icons/index": [
		94235,
		9,
		4235
	],
	"./home/assets/icons/index.js": [
		94235,
		9,
		4235
	],
	"./home/assets/icons/pin.png": [
		59309,
		1,
		9309
	],
	"./home/assets/icons/tv.png": [
		26597,
		1,
		6597
	],
	"./home/assets/images": [
		89820,
		9,
		8770,
		9820
	],
	"./home/assets/images/": [
		89820,
		9,
		8770,
		9820
	],
	"./home/assets/images/app-home-screen.png": [
		86560,
		1,
		6560
	],
	"./home/assets/images/app-home-screen.webp": [
		24292,
		1,
		4292
	],
	"./home/assets/images/bg-points.png": [
		16352,
		1,
		6352
	],
	"./home/assets/images/index": [
		89820,
		9,
		8770,
		9820
	],
	"./home/assets/images/index.js": [
		89820,
		9,
		8770,
		9820
	],
	"./home/assets/images/opaque-logo.png": [
		53610,
		1,
		3610
	],
	"./home/assets/images/potencialize.png": [
		80281,
		1,
		281
	],
	"./home/assets/images/potencialize.webp": [
		51754,
		1,
		1754
	],
	"./home/assets/images/quotes.png": [
		29675,
		1,
		9675
	],
	"./home/assets/images/testimonialsPics": [
		78770,
		9,
		8770
	],
	"./home/assets/images/testimonialsPics/": [
		78770,
		9,
		8770
	],
	"./home/assets/images/testimonialsPics/bottom-left.png": [
		54590,
		1,
		4590
	],
	"./home/assets/images/testimonialsPics/bottom-right.png": [
		51846,
		1,
		1846
	],
	"./home/assets/images/testimonialsPics/center-left.png": [
		50910,
		1,
		910
	],
	"./home/assets/images/testimonialsPics/center-right.png": [
		74858,
		1,
		4858
	],
	"./home/assets/images/testimonialsPics/index": [
		78770,
		9,
		8770
	],
	"./home/assets/images/testimonialsPics/index.js": [
		78770,
		9,
		8770
	],
	"./home/assets/images/testimonialsPics/upper-left.png": [
		91514,
		1,
		1514
	],
	"./home/assets/images/testimonialsPics/upper-right.png": [
		79249,
		1,
		9249
	],
	"./home/assets/index": [
		87054,
		9,
		8770,
		7054
	],
	"./home/assets/index.js": [
		87054,
		9,
		8770,
		7054
	],
	"./home/components": [
		2455,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		2455
	],
	"./home/components/": [
		2455,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		2455
	],
	"./home/components/benefitsSession": [
		78987,
		9,
		8770,
		7054,
		5958,
		8987
	],
	"./home/components/benefitsSession/": [
		78987,
		9,
		8770,
		7054,
		5958,
		8987
	],
	"./home/components/benefitsSession/index": [
		78987,
		9,
		8770,
		7054,
		5958,
		8987
	],
	"./home/components/benefitsSession/index.js": [
		78987,
		9,
		8770,
		7054,
		5958,
		8987
	],
	"./home/components/benefitsSession/styles.css": [
		98043,
		9,
		8043
	],
	"./home/components/index": [
		2455,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		2455
	],
	"./home/components/index.js": [
		2455,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		2455
	],
	"./home/components/servicesSession": [
		27971,
		9,
		8770,
		7054,
		5958,
		7971
	],
	"./home/components/servicesSession/": [
		27971,
		9,
		8770,
		7054,
		5958,
		7971
	],
	"./home/components/servicesSession/index": [
		27971,
		9,
		8770,
		7054,
		5958,
		7971
	],
	"./home/components/servicesSession/index.js": [
		27971,
		9,
		8770,
		7054,
		5958,
		7971
	],
	"./home/components/servicesSession/styles.css": [
		49126,
		9,
		9126
	],
	"./home/components/testimonials": [
		20610,
		9,
		1052,
		8770,
		7054,
		610
	],
	"./home/components/testimonials/": [
		20610,
		9,
		1052,
		8770,
		7054,
		610
	],
	"./home/components/testimonials/index": [
		20610,
		9,
		1052,
		8770,
		7054,
		610
	],
	"./home/components/testimonials/index.js": [
		20610,
		9,
		1052,
		8770,
		7054,
		610
	],
	"./home/components/testimonials/styles.css": [
		10391,
		9,
		391
	],
	"./home/index": [
		53226,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		3226
	],
	"./home/index.js": [
		53226,
		9,
		1052,
		8770,
		7054,
		5958,
		8987,
		3226
	],
	"./home/translations": [
		27204,
		9,
		7204
	],
	"./home/translations/": [
		27204,
		9,
		7204
	],
	"./home/translations/en": [
		8723,
		9,
		8723
	],
	"./home/translations/en/": [
		8723,
		9,
		8723
	],
	"./home/translations/en/index": [
		8723,
		9,
		8723
	],
	"./home/translations/en/index.js": [
		8723,
		9,
		8723
	],
	"./home/translations/index": [
		27204,
		9,
		7204
	],
	"./home/translations/index.js": [
		27204,
		9,
		7204
	],
	"./home/translations/pt-br": [
		92415,
		9,
		2415
	],
	"./home/translations/pt-br/": [
		92415,
		9,
		2415
	],
	"./home/translations/pt-br/index": [
		92415,
		9,
		2415
	],
	"./home/translations/pt-br/index.js": [
		92415,
		9,
		2415
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 83583;
module.exports = webpackAsyncContext;